import React from "react";
import {Icon, Tabs, Card, Form, Button, message} from "antd"
import {camelCase, get} from "lodash"
import { RequestV2 as Request } from "App/Utils";
import ComponentAutocomplete from 'App/Component/Autocomplete'
import {FormContext, FormProvider} from "App/Component/Context/ContextForm";
import DynamicField from "App/Component/DynamicField";
import LoadingSkleton from "App/Component/LoadingSkleton";
import styled from "styled-components";
import {Lib} from "App/Utils";
import History from "App/Screens/SubModules/Component/History";
const { TabPane } = Tabs;

class PageSetting extends React.PureComponent {

  state = {
    field: [],
    loading: false,
    readOnly: true,
    activeKey: "1"
  }

  onFailed=(err, l)=>{
    message.destroy()
    message.error('Something error on server')
    this.setState({loading: false, readOnly: true})
  }

  messageCustom = (type, msg) => {
    if (type !== 'loading') {
      message.destroy();
      this.setLoading(false);
    } else {
      this.setLoading(true);
    }
    return (
      message[type](msg)
    )
  };

  setLoading = (val) => {
    this.setState({loading: val})
  };

  onSave(form) {
    this.messageCustom('loading', 'Saving data..');
    const {validateFieldsAndScroll, resetFields} = form;
    validateFieldsAndScroll({scroll: {offsetTop: 150}}, (err, values) => {
      values.branch = values.branch.key
      this.request = Request(
        "put",
        "module-jobQueue-detail",
        {},
        values,
        [this.props.jobQueue.pk],
        this.editSuccess,
        this.onFailed,
        resetFields
      );
    })
  }

  editSuccess=(response)=>{
    this.setState({ readOnly: true, loading: false })
    this.props.changeJobQueue(response.data)
    this.messageCustom('success', 'Update successfully');
  }

  hasErrors(fieldsError) {
    // Return Boolean
    return Object.keys(fieldsError).some(field => fieldsError[field]);
  }

  onCancel = (form) => {
    this.resetFields(form, () => {
      this.setState({ readOnly: true })
    })
  }

  resetFields = (form, callback = () => null) => {
    const { field } = this.state
    const { jobQueue } = this.props
    const values = {}
    for (let i = 0; i < field.length; i += 1) {
      const decoratorName = Lib.decoratorName(field[i].title)
      if (field[i].type === 'SelectQuery') {
        values[decoratorName] = Lib.setSelectValue(jobQueue[decoratorName], field[i].selectedKey, field[i].selectedLabel)
      } else {
        values[decoratorName] = jobQueue[decoratorName]
      }
    }
    form.setFieldsValue(values, callback)
  }

  componentDidMount() {
    let customField = ComponentAutocomplete[camelCase("jobQueues")]
    customField[2].additional = undefined
    this.setState({
      field: customField
    })
  }

  render() {
    const {loading, readOnly ,field, activeKey} = this.state
    const {userReducer, jobQueue, changeJobQueue} = this.props
    let totalCount = field.length

    return (
      <Card>
        {
          !loading ?
            <Tabs activeKey={activeKey} onChange={(activeKey)=>this.setState({ activeKey })} tabPosition={"left"}>
              <TabPane tab="Edit" key="1">
                <FormProvider>
                  <Form layout="horizontal" style={{height: "400px"}}>
                    { field && field.map((elem, index) => {
                      let datafield = (elem.dataIndex) && get(jobQueue, elem.dataIndex.split('.'))
                      return (
                        <DynamicField
                          {...elem}
                          onBlur={()=>null}
                          normFile={()=>null}
                          toggleDrawerSQ={()=>null}
                          operation={readOnly ? "view" : "edit"}
                          userReducer={userReducer}
                          dataRecord={datafield}
                          key={index}
                        />
                      );
                    })}
                    <FormContext.Consumer>
                      {(form) => (
                        <StyledFooter>
                          { readOnly ?
                            <StyledButton
                              onClick={() => {
                                this.setState({readOnly: false})
                              }} type="danger"
                              disabled={loading}
                            >
                              <Icon type="edit"/>  Edit
                            </StyledButton> :
                            <>
                              <StyledButton type="danger" loading={loading} onClick={() => this.onCancel(form)}>
                                Cancel
                              </StyledButton>
                              <StyledButton
                                onClick={() => this.onSave(form)}
                                type="primary"
                                disabled={loading || this.hasErrors(form.getFieldsError())}
                              >
                                <Icon type="save" theme="filled" /> Save
                              </StyledButton>
                            </>
                          }
                        </StyledFooter>
                      )}
                    </FormContext.Consumer>
                  </Form>
                </FormProvider>
              </TabPane>
              <TabPane tab="History" key="2">
                <History 
                  url="module-jobQueue-history" 
                  urlDetail="module-jobQueue-history-detail" 
                  id={get(this.props, 'match.params.id')} 
                  title={get(jobQueue, 'name')} 
                  fields={field}
                  updateHeader={(data)=>{
                    changeJobQueue(data)
                    this.setState({ activeKey: "1" })
                  }}
                />
              </TabPane>
            </Tabs>
            :
            <LoadingSkleton count={totalCount}/>
        }
      </Card>
    )
  }
}

export default PageSetting;

const StyledButton = styled(Button)`
  margin-right: 8px;
`;

const StyledFooter = styled.div`
  position: fixed;
  right: 8px;
  bottom: 10px;
  width: calc(100% - 300px);
  border-top: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
`;
